import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';


import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

//Lista de mecanismos del informe
// const DetallePl = ({elemento, handleClickidLista}) => {
const DetallePl = ({elemento}) => {
  return(
    // <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
    <tr className=''>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroInflab}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaMuestra}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoInflab}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.prioridad?elemento.prioridad:'Normal'}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetallePl elemento={elemento}
        // handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class LabBuscInf2 extends React.Component {
  state={argsBuscInf: {} 
}

  componentDidUpdate(prevProps){
            // if(this.props.argsBuscInf!==this.state.argsBuscInf){
        if(this.props.argsBuscInf.descrEmpresa || this.props.argsBuscInf.descrPlanta || this.props.argsBuscInf.descrSeccion || this.props.argsBuscInf.descrEquipo || this.props.argsBuscInf.descrComponente || this.props.argsBuscInf.descrMecanismo || this.props.argsBuscInf.prioridad || this.props.argsBuscInf.numDocum){  
console.log("1111111")
          let argsBuscar = `'numeroInflab': {$gt: 0}`

          if(this.props.argsBuscInf.descrEmpresa){
            argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscInf.descrEmpresa}/i`
          }          
          if(this.props.argsBuscInf.descrPlanta){
            argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
          }
          if(this.props.argsBuscInf.descrSeccion){
            argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
          }
          if(this.props.argsBuscInf.descrEquipo){
            argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
          }
          if(this.props.argsBuscInf.descrComponente){
            argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
          }
          if(this.props.argsBuscInf.descrMecanismo){
            argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
          }
          if(this.props.argsBuscInf.prioridad){
            argsBuscar += `, 'prioridad': /${this.props.argsBuscInf.prioridad}/i`
          }

          let argsBuscInf = ""
          if(this.props.argsBuscInf.numDocum){
            argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: ${this.props.argsBuscInf.numDocum}}]`}
          }else{
            argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: 100}]`}
          }
          this.props.allInflabRtes2.refetch(argsBuscInf)
    
          // this.setState({argsBuscInf: this.props.argsBuscInf})
        }
      }

  render(){
    // const {errors} = this.state;
    console.log("222222")
    let list = []
    if(this.props.argsBuscInf.descrEmpresa || this.props.argsBuscInf.descrPlanta || this.props.argsBuscInf.descrSeccion || this.props.argsBuscInf.descrEquipo || this.props.argsBuscInf.descrComponente || this.props.argsBuscInf.descrMecanismo || this.props.argsBuscInf.prioridad || this.props.argsBuscInf.numDocum){  
      if(this.props.allInflabRtes2.allInflabRtes){list = this.props.allInflabRtes2.allInflabRtes}
    }
    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <div>
            <div style={{height: '56em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Rep</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Prioridad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nombre del aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de frecuencia</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.props.handleClickidLista}/>
              </table>
              <p></p>
            </div>
          </div>            
          {
            // errors.length?<Message negative header="Los siguientes errores:"
            // list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {numeroInflab: -1}}, {$sort: {numeroInflab: -1}}, {$limit : 100}]`}}}}),

  // graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),

)(LabBuscInf2)
